import React from "react";
import { Card } from "antd";
import { EmailTemplate } from "../data";
import TemplatePreview from "../TemplatePreview";

import styles from "./index.module.scss";

interface TemplateCardProps {
  template: EmailTemplate;
  onPick: (template: EmailTemplate) => void;
}

/**
 * One template, as a card with the top of the letter over its name.
 *
 * Both places a template is offered use this: the picker on the list screen and
 * the Templates section of the builder's Blocks panel. They differ in how many
 * fit across — that is the grid around them — not in what a template looks like.
 */
export default function TemplateCard({ template, onPick }: TemplateCardProps) {
  return (
    // The card is a button so it stays reachable by keyboard and is announced
    // as an action; Card renders a div, and an onClick on a div gives neither.
    // Everything visual — the border, the radius, the padding, the lift on
    // hover — comes from Card itself.
    <button
      type="button"
      className={styles.tile}
      onClick={() => onPick(template)}
    >
      <Card hoverable size="small" cover={<TemplatePreview id={template.id} />}>
        <Card.Meta title={template.name} />
      </Card>
    </button>
  );
}
